import { InjectionToken } from '@angular/core';

export const LANGUAGE_HTTP_ORIGIN = new InjectionToken('Language http origin');
